import { gql } from '@apollo/client/core';

export const SearchUsersQuery = gql`
  query SearchUsers($query: String, $boostUserUsernames: String) {
    searchUsers(query: $query, boostUserUsernames: $boostUserUsernames) {
      username
      warRoomAvatarUrl
    }
  }
`;
